import React, { useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { API_CONFIG } from '../config/api';

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

const PasswordReset = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const token = query.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    if (password.length < 6) return setError('Lozinka mora imati najmanje 6 znakova.');
    if (password !== confirm) return setError('Lozinke se ne podudaraju.');
    setLoading(true);
    try {
      const res = await fetch(API_CONFIG.ENDPOINTS.PASSWORD_RESET, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password })
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || 'Reset lozinke nije uspio.');
      setSuccess('Lozinka je uspješno promijenjena. Možete se prijaviti.');
      setTimeout(() => navigate('/login'), 1500);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white border border-gray-200 rounded-2xl shadow-sm p-6 md:p-8">
        <h1 className="text-2xl font-semibold text-gray-900">Postavi novu lozinku</h1>
        <p className="text-sm text-gray-600 mt-1">Unesite novu lozinku za vaš nalog.</p>
        <form onSubmit={handleSubmit} className="mt-4 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Nova lozinka</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 px-3 py-3"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Potvrdi lozinku</label>
            <input
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
              className="mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 px-3 py-3"
            />
          </div>
          {error && <div className="p-3 text-sm text-red-700 bg-red-100 rounded-md">{error}</div>}
          {success && <div className="p-3 text-sm text-green-700 bg-green-100 rounded-md">{success}</div>}
          <button type="submit" disabled={loading} className="w-full py-3 rounded-md bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50">{loading ? 'Spremanje...' : 'Spremi lozinku'}</button>
        </form>
      </div>
    </div>
  );
};

export default PasswordReset;
